import { Badge } from "reactstrap";
import { LI } from "../../../../AbstractElements";
import { SidebarIconProp } from "../../../../Type/CustomizerType";
import CommonUL from "../../Common/CommonUL";

const StrokeIcon = ({ handleSideBarIconType, sideBarIconType }: SidebarIconProp) => {
  return (
    <LI className={`normal-sidebar border-0 ${sideBarIconType === "stroke" ? "active" : ""}`} onClick={() => handleSideBarIconType("stroke")}>
      <div className="header bg-light">
        <CommonUL />
      </div>
      <div className="body">
        <div className="body bg-light">
          <Badge color="primary">Stroke</Badge>
        </div>
      </div>
    </LI>
  );
};

export default StrokeIcon;
